import { jsx } from 'react/jsx-runtime';
import { useResourceTagsStore } from './resourceTagsStore.js';
import { useQueryResourceTags } from '../../queries/useQueryResourceTags.js';
import { useMutationResourcesTagAssign } from '../../mutations/useMutationResourcesTagAssign.js';
import { MagicSuggestionsContextProvider } from '../../../magic/components/MagicSuggestionsContext.js';
import EditTagsModal from '../EditTagsModal.js';
import { pick } from '@fabric-app/utils/object/manipulation';

const ModalResourceTagsWithGlobalState = () => {
  const { close, resourceId: resourceIdGlobalState } = useResourceTagsStore((state) => pick(state, [
    "close",
    "resourceId"
  ]));
  const queryResourceTags = useQueryResourceTags(resourceIdGlobalState);
  const { mutate: mutateResourcesTagAssign } = useMutationResourcesTagAssign();
  const onSelectTag = (tag, selected) => {
    if (resourceIdGlobalState) {
      mutateResourcesTagAssign({
        tag,
        resourceIds: [
          resourceIdGlobalState
        ],
        operation: selected ? "assign" : "unassign"
      });
    }
  };
  return /* @__PURE__ */ jsx(MagicSuggestionsContextProvider, {
    context: resourceIdGlobalState ? {
      resourceId: resourceIdGlobalState
    } : void 0,
    includeFolders: false,
    children: /* @__PURE__ */ jsx(EditTagsModal, {
      open: !!resourceIdGlobalState,
      onOpenChange: close,
      selectedTags: queryResourceTags.data,
      onSelect: onSelectTag,
      selectedResourcesCount: 1
    })
  });
};

export { ModalResourceTagsWithGlobalState };
//# sourceMappingURL=ModalResourceTagsWithGlobalState.js.map
